import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

export interface HttpResponse {
    head: {
        status: number,
        errorMsg: string,
        errorCode: string,
        extention: string,
        requestCode: string
    };
    body?: any;
}

export let urlBase = environment.urlBase || '/srm-manager/';

@Injectable()
export class HttpService {
    loading$ = new Subject<boolean>();

    constructor(private http: HttpClient) { }

    get host() {
        // console.log(this.http.get);
        return 'http service ready';
    }

    get(url, options: any, useLoading = false) {
        // options.responseType = 'json';
        if (useLoading) {
            // console.log(url);
            // // this.loading$.next(true);
            // return Observable.of(true).do(x => { this.loading$.next(true); })
            //     .switchMap(x => this.http.get<HttpResponse>(urlBase + url, options))
            //     .do(x => this.loading$.next(false));
        }
        return this.http.get<HttpResponse>(urlBase + url, options);
    }

    post(url, data, useLoading = false, options?: {
        headers?: HttpHeaders;
        observe?: 'body';
        params?: HttpParams;
        reportProgress?: boolean;
        withCredentials?: boolean;
    }) {
        if (useLoading) {
            // console.log(url);
            // return Observable.of(true)
            //     .do(x => { this.loading$.next(true); })
            //     .switchMap(x => this.http.post<HttpResponse>(urlBase + url, data, options || {}))
            //     .do(x => this.loading$.next(false));
        }
        return this.http.post<HttpResponse>(urlBase + url, data, options || {});

    }

    get BaseUrl() {
        return urlBase;
    }

    getUrl(url, options?) {
        let params = '';
        if (options) {
            params = '?' + Object.keys(options).map(x => {
                let val = options[x];
                if (typeof val !== 'string') {
                    val = JSON.stringify(val);
                }
                return x + '=' + encodeURIComponent(val);
            }).join('&');
        }
        return urlBase + url + params;
    }

    mapRes(res) {
        if (res && res['head'] && res['head'].status === 1) {
            return Observable.of(res['body'] || true);
        } else if (res && res['head'] && res['head'].errorMsg) {
            return Observable.throw(res['head'].errorMsg);
        } else {
            return Observable.throw('error');
        }
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/services/http.service.ts